import React from 'react';
import { ReactFlowProvider } from '@xyflow/react';
import FlowDevices from './FlowDevices';

interface UnifiedDevicesProps {
  siteId: string;
  companyId: string;
}

export const UnifiedDevices: React.FC<UnifiedDevicesProps> = ({ siteId, companyId }) => {
  return (
    <ReactFlowProvider>
      <FlowDevices siteId={siteId} companyId={companyId} />
    </ReactFlowProvider>
  );
};

export default UnifiedDevices;